<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            <div class="left">
              <div class="modal-title">联系我们</div>
              <spin :uid="uid">
                <div class="country-wrapper">
                  <div
                    v-for="(item, index) in countryItems"
                    :key="index"
                    :class="{ item: 1, active: countryAction == index }"
                    @click="setCur(item.tenantId, index)"
                  >
                    <div class="icon">
                      <img :src="item.logo | formatUrl" alt="" v-if="item.id" />
                      <img src="../assets/tenant_all.svg" alt="" v-else />
                    </div>
                    <span :title="item.countryAbbreviation">{{
                      item.countryAbbreviation
                    }}</span>
                  </div>
                </div>
                <div
                  class="info-list"
                  v-if="
                    contactMe[countryAction] &&
                    contactMe[countryAction].result.length
                  "
                >
                  <div
                    class="info-item"
                    v-for="(item, index) in contactMe[countryAction].result"
                    :key="index"
                  >
                    <div class="address">
                      {{ item.name }}<span class="line">|</span>{{ item.path }}
                    </div>
                    <div class="contact align-center">
                      联系人：{{
                        item.contactInformationList[0].contacts
                      }}&emsp; 电话：<span>{{
                        item.contactInformationList[0].phone
                      }}</span
                      >&emsp;
                      <template
                        v-if="
                          item.contactInformationList[0].qrCodePath ||
                          item.contactInformationList[0].chatNum
                        "
                      >
                        <span
                          v-if="
                            !item.contactInformationList[0].qrCodePath &&
                            item.contactInformationList[0].chatNum
                          "
                        >
                          微信号：<span>{{
                            item.contactInformationList[0].chatNum
                          }}</span>
                        </span>
                        <span v-else class="align-center">
                          微信号：<span
                            class="code-text"
                            v-if="item.contactInformationList[0].chatNum"
                            >{{ item.contactInformationList[0].chatNum }}</span
                          >
                          <Popover>
                            <img
                              src="../assets/weixin_icon.svg"
                              slot="trigger"
                              class="allow-pointer erweima"
                            />
                            <div slot="content">
                              <img
                                :src="item.contactInformationList[0].qrCodePath"
                                class="qr-code"
                              />
                            </div>
                          </Popover>
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="loading-container" v-if="loading">
                  <div class="spin-container">
                    <div class="spin"></div>
                  </div>
                </div>
              </spin>
            </div>
            <div class="right">
              <span class="modal-close" @click="$emit('close')">
                <img src="../assets/close-icon.svg" alt="" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as api from "@/api";
import Popover from "@/components/Popover.vue";
import { mapState } from "vuex";
import Spin from '@/components/Spin.vue'
import { randomUUID } from '@/utils'
export default {
  components: {
    Popover,
    Spin
  },
  data() {
    return {
      countryAction: 0,
      countryItems: [],
      contactMe: [],
      loading: false,
      uid: randomUUID(),
    };
  },
  computed: mapState({
    currentCountry: (state) => state.currentCountry,
  }),
  created() {
    this.getCountryList();
  },
  methods: {
    async getCountryList() {
      this.loading = true;
      const { result } = await api.fetchCountry({
        state: 0,
        about: "aboutMe",
      }, { uid: this.uid });
      let arr = result.records || [];
      this.countryItems = arr.filter((item) => item.haveCompany === 1);
      let isExist = this.countryItems.some(
        (item) => item.tenantId === this.currentCountry.tenantId
      );
      let tenantId = "";
      if (!isExist && this.countryItems.length) {
        tenantId = this.countryItems[0].tenantId;
      } else {
        tenantId = this.currentCountry.tenantId;
      }
      this.contactMe = this.countryItems.map(() => {
        return {
          result: [], // 每个国家的分公司数据
        };
      });
      this.contactMe = [...this.contactMe];
      this.getContactMe(tenantId);
      this.setAction(tenantId);
    },
    async getContactMe(tenantId) {
      if (this.contactMe[this.countryAction].result.length) {
        this.loading = false;
        return; // 没有公司数据，则请求加载
      }
      this.loading = true;
      const { result } = await api.getContactMe({ tenantId }, { uid: this.uid });
      this.contactMe[this.countryAction].result = result || [];
      this.contactMe = [...this.contactMe];
      this.loading = false;
    },
    setCur(tenantId, index) {
      this.countryAction = index;
      this.getContactMe(tenantId);
    },
    setAction(tenantId) {
      this.countryItems.forEach((item, index) => {
        if (item.tenantId === tenantId) {
          this.countryAction = index;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@commomColor: #2a5dfb;
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 764px;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  position: relative;
}

.modal-title {
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  position: relative;
  padding-left: 37px;
  line-height: 58px;

  &::before {
    content: "";
    position: absolute;
    left: 26px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 18px;
    background-color: #2d54f9;
  }
}
.modal-close {
  position: absolute;
  right: 7px;
  cursor: pointer;
  padding: 20px;
  img {
    width: 16px;
    height: 16px;
  }
}
/deep/ .content_wrap {
  display: flex;
  flex-direction: column;
}
.modal-body {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
  position: relative;
  .country-wrapper {
    border-bottom: 1px solid #ededed;
    display: flex;
    flex-wrap: wrap;
    margin: 0 23px 0 34px;
  }
  .item {
    cursor: pointer;
    position: relative;
    user-select: none;
    width: 96px;
    height: 40px;
    white-space: nowrap;
    border: 1px solid rgba(185, 185, 185, 0.2);
    margin-bottom: 11px;
    margin-right: 9px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 7px;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: @commomColor;
      background: rgba(42, 93, 251, 0.2);
      border: 1px solid rgba(42, 93, 251, 0.2);
    }
    &.active {
      font-size: 15px;
      position: relative;
      background: rgba(42, 93, 251, 0.2);
      border: 1px solid rgba(42, 93, 251, 0.2);
      span {
        color: @commomColor;
      }
    }
    span {
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
      font-size: 16px;
    }
    .icon {
      width: 18px;
      height: 18px;
      margin-right: 7px;
      border: 1px solid #d8d8d8;
      overflow: hidden;
      border-radius: 50%;
      flex-shrink: 0;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .info-list {
    margin: 15px 23px 0 34px;
    overflow-y: auto;
    // flex: 1;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      border-radius: 8px;
      border: 1px solid transparent;
      background-clip: padding-box;
    }
  }
  .info-item {
    font-size: 16px;
    margin-bottom: 30px;
    .address {
      color: #000000;
      margin-bottom: 8px;
      .line {
        margin: 0 5px;
      }
    }
    .contact {
      color: rgba(0, 0, 0, 0.5);
      margin-bottom: 4px;
    }
  }
  .left {
    flex: 1;
    height: 543px;
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .right {
    width: 180px;
    height: 543px;
    background: url("../assets/frame-bg.webp") no-repeat center center;
    background-size: 100%;
    position: relative;
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.loading-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
  .spin-container {
    width: 30px;
    height: 30px;
    border: 3px solid transparent;
    border-top: 3px solid #1890ff;
    border-radius: 50%;
    animation: spin 0.5s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
.align-center {
  display: flex;
  align-items: center;
}
.qr-code {
  width: 150px;
  max-height: 200px;
  object-fit: contain;
  margin-bottom: 2px;
}
.erweima {
  display: block;
}
.allow-pointer {
  cursor: pointer;
}
.code-text {
  margin-right: 6px;
}
</style>
